import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { JournalService } from '../journal.service';
import { MainBodyService } from '../../services/main-body.service';
import { themeData, journalData, responsedata, journalResponse } from 'src/interface/themesetting';
import { JournalType } from 'src/interface/book'
import { EnvService } from '../../services/env.service';
import { Subscription } from 'rxjs';
import { PublisherService } from '../../services/publisher.service';

@Component({
    selector: 'app-journal-listing',
    templateUrl: './journal-listing.component.html',
    styleUrls: ['./journal-listing.component.scss']
})
export class JournalListingComponent implements OnInit, OnDestroy {
    imageUrl: string;
    themeSettingsData: themeData;
    journalId: string;
    journalData: journalData[];
    defaultJournalCoverImage = '';
    defaultJournalLogo = '';
    journal_id: string;
    publisher_id: string;
    subscriptionArr: Subscription[] = [];
    constructor(
        private service: JournalService,
        private mainBodyService: MainBodyService,
        private envService: EnvService,
        private publisherService: PublisherService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
    }

    ngOnInit(): void {
        const fetchpublishersubs = this.publisherService.fetchPublisherId().subscribe(response => {
            this.publisher_id = response[0].publisher_id;
            this.imageUrl = this.envService.imageUrl + 'themes/'
            this.defaultJournalCoverImage = this.envService.defaultImagePath + this.envService.default_journalCoverImage;
            this.defaultJournalLogo = this.envService.defaultImagePath + this.envService.default_journalLogo;

            this.mainBodyService.urlchange(false);
            const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.publisher_id).subscribe((result: responsedata) => {
                this.themeSettingsData = result.data;
                if (isPlatformBrowser(this.platformId)) {
                    Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                        const element = "--" + key;
                        const val: string = value;
                        document.documentElement.style.setProperty(element, val);
                    });
                }
            });
            this.subscriptionArr.push(getallthemesubs);
            const journalType: JournalType = { jnl_type: "JNL" }
            const journalsubs = this.service.getJournals(journalType).subscribe((result: journalResponse) => {
                this.journalData = result.data;

            })
            this.subscriptionArr.push(journalsubs);
        });
        this.subscriptionArr.push(fetchpublishersubs);
    }

    ngOnDestroy() {
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
}


